import api from '@/api'
import store from '@/utils/store.js'

const state = () => ({
  gemeinden: [],
  types: [],
  states: [],
  loadingCounter: 0,
})

const mutations = {
  SET_STATES(state, states) {
    state.states = states
  },
  SET_TYPES(state, types) {
    state.types = types
  },
  SET_GEMEINDEN(state, gemeinden) {
    state.gemeinden = gemeinden
  },
  INCREMENT_LOADING_COUNTER(state, value = 1) {
    state.loadingCounter += value
  },
  DECREMENT_LOADING_COUNTER(state, value = 1) {
    state.loadingCounter -= value
  }
}

const actions = {
  async loadStates({ state, commit }) {
    if (state.states.length === 0) {
      commit('INCREMENT_LOADING_COUNTER')

      let states

      if (await store.has('states')) {
	states = await store.get('states')
      }
      else {
	states = await api.fetchProtokollStates()
	await store.set('states', states)
      }

      commit('SET_STATES', states)
      commit('DECREMENT_LOADING_COUNTER')
    }
  },
  async loadTypes({ state, commit }) {
    if (state.types.length === 0) {
      commit('INCREMENT_LOADING_COUNTER')

      let types

      if (await store.has('types')) {
	types = await store.get('types')
      }
      else {
	types = await api.fetchProtokollTypes()
	await store.set('types', types)
      }

      commit('SET_TYPES', types)
      commit('DECREMENT_LOADING_COUNTER')
    }
  },
  async loadGemeinden({ state, commit }) {
    if (state.gemeinden.length === 0) {
      commit('INCREMENT_LOADING_COUNTER')

      if (await store.has('gemeinden')) {
	var items = await store.get('gemeinden')
      }
      else {
	// var { items } = await api.fetchGemeinden({ limit: 1000 })
	// await store.set('gemeinden', items)
      }

      commit('SET_GEMEINDEN', items)
      commit('DECREMENT_LOADING_COUNTER')
    }
  },
  async load({ state, getters, dispatch, commit }) {
    if (state.loadingCounter === 0 && !getters.ready) {
      commit('INCREMENT_LOADING_COUNTER')
      await Promise.all([
	await dispatch('loadGemeinden'),
	await dispatch('loadTypes'),
	await dispatch('loadStates')
      ])
      commit('DECREMENT_LOADING_COUNTER')
    }
  }
}

const getters = {
  loading: (state) => state.loadingCounter > 0,
  ready: (state) => state.gemeinden.length > 0 && state.types.length > 0 && state.states.length > 0,
  validate: (state) => (what, field, value) => state[what].some(entry => entry[field] === value),
  defaultTypes: (state) => state.types.length > 0
    ? state.types.filter((type) => type.isDefault)
    : [],
  findGemeindeById: (state) => (id) => state.gemeinden.length > 0
    ? state.gemeinden.filter((gemeinde) => gemeinde.id == id).pop()
    : [],
  findTypeById: (state) => (id) => state.types.length > 0
    ? state.types.filter((type) => type.id == id).pop()
    : [],
  findStateById: (state) => (id) => state.states.length > 0
    ? state.states.filter((type) => state.id == id).pop()
    : []
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
